<template>
  <fieldset :class="'share-url ' + 'share-url--'+network.api_type">
      <label class="share-url-label"  :for="`share-url-${post.id}-network-${network.id}`">
        <i :class="networkIconClass"></i>
      </label>
      <input 
        type="url" 
        :name="`share-url-${post.id}-network-${network.id}`" 
        :id="`share-url-${post.id}-network-${network.id}`" 
        v-model="url" 
        @blur="shareUrlSubmitted" 
        @keyup.enter="shareUrlSubmitted"
        @change="shareUrlUpdated"
        :disabled="urlDisabled"
      />
      <div class="retweet-wrapper" v-if="network.api_type == 'twitter'">
      <i class="fas fa-comment" @click="urlOnlySwitch= false; urlUpdated = true; "></i>
      <switches v-model="urlOnlySwitch" emit-on-mount="false"></switches>
      <i class="fas fa-retweet" @click="urlOnlySwitch= true;  urlUpdated = true; "></i>
    	</div>
    </fieldset>
</template>


<script>
import Switches from 'vue-switches';
import { mapState } from "vuex";


export default {
  data() {
    return {
      url: "",
      urlDisabled: false,
      urlUpdated: false,
      urlOnly:false,
      urlOnlySwitch:false,
    }
  },
  props: ['shareUrl', 'network', 'post'],
    components: {
      Switches,
  },
  computed: {
	    ...mapState({
	      state(state) {
	        return state[this.namespace]
	      },

	      getSocialNetworkClass(state, getters) {
	        return getters['getSocialNetworkClass']
	      },
	   }),

    networkIconClass(){
      let iconClass = 'fab fa-'+this.getSocialNetworkClass(this.network.api_type);
      let classObj = {}
      classObj[iconClass] = true;
      return classObj;
    },
    storedShareUrl(){
      return this.post.share_urls.filter(x => x.id === this.network.id)[0];
    },
  },
  methods: {
    shareUrlUpdated(){
      this.urlUpdated = true;
    },
    shareUrlSubmitted(){
      if(this.urlUpdated){
        if(this.url != "" || this.shareUrl.url != null){
          this.urlDisabled = true;
          let that = this;
          this.$store.dispatch("updateSocialPostNetworkShareUrl", {
            id: this.post.id,
            social_network_id: this.shareUrl.id,
            value: this.url,
            only_share_url: this.urlOnly
          }).then(function(){
            that.urlUpdated = false;
            that.urlDisabled = false;
            that.$emit("updated", {
            id: that.post.id,
            social_network_id: that.shareUrl.id,
            url: that.url,
            only_share_url: that.urlOnly
            });
          });
        }
      }
    },
  },
  created(){
    this.url = this.shareUrl.url;
    if(this.url == null){
      this.url = "";
    }
    if (this.shareUrl.only_share_url == 1) {
    	this.urlOnly = true;
  	} else {
  		this.urlOnly = false;
  	}
  	this.urlOnlySwitch = this.urlOnly;
  },
  watch: {
    shareUrl(){
      this.url = this.shareUrl.url;
      if (this.shareUrl.only_share_url == 1) {
      	this.urlOnly = true;
    	} else {
    		this.urlOnly = false;
    	}
    },
    urlUpdated() {
    	if (this.urlUpdated && this.url != this.shareUrl.url) {
    		this.shareUrlSubmitted();
    	}
    },
    urlOnlySwitch() {
    	this.urlOnly = this.urlOnlySwitch;
    	this.urlUpdated = true;
   		this.shareUrlSubmitted();
    },
  }
}
</script>
<style scoped>
.share-url {
	position:relative;
	}
label.share-url-label {
	position:absolute;
	top: 10px;
	left: 13px;
	}
input {
	padding-left:40px !important;

}
.share-url--twitter input {
	width:65% !important;
}

.fa-x-twitter,
.fa-twitter {
	color: var(--sm--initials-bg--fa-twitter-facebook) !important;
}
.fa-facebook {
	color: var(--sm--initials-bg--fa-twitter-facebook) !important;
}
.fa-instagram {
	color: var(--sm--initials-bg--fa-instagram) !important;
}
.fa-linkedin {
	color: var(sm--initials-bg--fa-linkedin)  !important;
}
.vue-switcher {
	top:10px;
	margin-left:10px;
	margin-right:10px;

	}

	.vue-switcher-theme--default.vue-switcher-color--default.vue-switcher--unchecked div::after {
		background-color: var(--wf-primary) !important;
	}
	.vue-switcher-theme--default.vue-switcher-color--default div::after {
		background-color: var(--wf-primary) !important;
	}
	.vue-switcher div::after {
		background-color: var(--wf-primary) !important;
	}



.retweet-wrapper {
	display:inline-block;
	margin-left:5px;
}
</style>